import { ChevronRightIcon } from "@heroicons/react/24/outline";

import { classNames } from "../../../common/lib/classNames";
import { IHeroIcon } from "../../../main/types/types";

const tones = {
  brand: `bg-paidniceGreen-50 text-paidniceGreen-600`,
  blue: `bg-blue-50 text-blue-700`,
  orange: `bg-orange-50 text-orange-700`,
};

interface InvoiceOptionProps {
  icon: IHeroIcon;
  title: string;
  description: string;
  tone?: keyof typeof tones;
  /** Without a click handler the row is a status line with no chevron */
  onClick?: () => void;
}

/** A row in the "Other options" card of the invoice pay rail */
export function InvoiceOption({ icon: Icon, title, description, tone = `brand`, onClick }: InvoiceOptionProps) {
  const Tag = onClick ? `button` : `div`;

  return (
    <Tag
      type={ onClick ? `button` : undefined }
      onClick={ onClick }
      className={ classNames(
        `flex w-full items-center gap-3 border-t border-gray-100 bg-white px-5 py-3 text-left text-gray-900`,
        // Status rows sort above the actions in the flex column
        onClick ? `cursor-pointer hover:bg-gray-50` : `order-first`,
      ) }
    >
      <span className={ classNames(`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg`, tones[tone]) }>
        <Icon className={ `h-[1.0625rem] w-[1.0625rem]` } />
      </span>
      <span className={ `flex min-w-0 flex-1 flex-col gap-0.5` }>
        <span className={ `text-sm font-medium` }>{ title }</span>
        <span className={ `text-pretty text-[0.8125rem] leading-[1.45] text-gray-500` }>{ description }</span>
      </span>
      { onClick ? <ChevronRightIcon className={ `h-4 w-4 shrink-0 text-gray-400` } /> : null }
    </Tag>
  );
}
